<template>
  <div>
    <a-card
      :bordered="false"
      style="margin-bottom: 16px"
      :body-style="{ padding: '12px 16px 4px' }"
    >
      <!-- 统计头 -->
      <div class="statistics-container">
        <div class="statistic-item">
          <div class="module-header-fs14" style="margin-bottom: 6px">
            请求数
          </div>
          <div class="item-card">
            <div class="title">>100 / ≤100</div>
            <div class="value">
              {{
                isNotUndefined(resourceStatusData.request_count?.below)
                  ? resourceStatusData.request_count.below
                  : '-'
              }}
              /
              {{
                isNotUndefined(resourceStatusData.request_count?.above)
                  ? resourceStatusData.request_count.above
                  : '-'
              }}
            </div>
          </div>
        </div>

        <div class="statistic-item">
          <div class="module-header-fs14" style="margin-bottom: 6px">P95</div>
          <div class="item-card">
            <div class="title">>1 / ≤1</div>
            <div class="value">
              {{
                isNotUndefined(resourceStatusData['95th_request_time']?.below)
                  ? resourceStatusData['95th_request_time'].below
                  : '-'
              }}
              /
              {{
                isNotUndefined(resourceStatusData['95th_request_time']?.above)
                  ? resourceStatusData['95th_request_time'].above
                  : '-'
              }}
            </div>
          </div>
        </div>

        <div class="statistic-item">
          <div class="module-header-fs14" style="margin-bottom: 6px">
            平均响应成功率
          </div>
          <div class="item-card">
            <div class="title">>95% / ≤95%</div>
            <div class="value">
              {{
                isNotUndefined(resourceStatusData.requests_success_rate?.below)
                  ? resourceStatusData.requests_success_rate.below
                  : '-'
              }}
              /
              {{
                isNotUndefined(resourceStatusData.requests_success_rate?.above)
                  ? resourceStatusData.requests_success_rate.above
                  : '-'
              }}
            </div>
          </div>
        </div>

        <div class="statistic-item">
          <div class="module-header-fs14" style="margin-bottom: 6px">
            繁忙设备数
          </div>
          <div class="item-card">
            <div class="title">>3 / ≤3</div>
            <div class="value">
              {{
                isNotUndefined(resourceStatusData.busy_count?.below)
                  ? resourceStatusData.busy_count.below
                  : '-'
              }}
              /
              {{
                isNotUndefined(resourceStatusData.busy_count?.above)
                  ? resourceStatusData.busy_count.above
                  : '-'
              }}
            </div>
          </div>
        </div>

        <div class="statistic-item">
          <div class="module-header-fs14" style="margin-bottom: 6px">
            空闲设备数
          </div>
          <div class="item-card">
            <div class="title">>3 / ≤3</div>
            <div class="value">
              {{
                isNotUndefined(resourceStatusData.idle_count?.below)
                  ? resourceStatusData.idle_count.below
                  : '-'
              }}
              /
              {{
                isNotUndefined(resourceStatusData.idle_count?.above)
                  ? resourceStatusData.idle_count.above
                  : '-'
              }}
            </div>
          </div>
        </div>

        <div class="statistic-item">
          <div class="module-header-fs14" style="margin-bottom: 6px">
            健康度
          </div>
          <div class="item-card">
            <div class="title">>80 / ≤80</div>
            <div class="value">
              {{
                isNotUndefined(resourceStatusData.health_score_count?.below)
                  ? resourceStatusData.health_score_count.below
                  : '-'
              }}
              /
              {{
                isNotUndefined(resourceStatusData.health_score_count?.above)
                  ? resourceStatusData.health_score_count.above
                  : '-'
              }}
            </div>
          </div>
        </div>
      </div>

      <!-- Top -->
      <a-row v-if="visible" :gutter="16" class="top-container">
        <a-col :span="8" style="margin-bottom: 16px">
          <div class="top-item">
            <div class="module-header-fs14" style="margin-bottom: 12px">
              设备繁忙数Top3
            </div>
            <div class="item-card">
              <template v-if="deviceBusyTop && deviceBusyTop.length">
                <alert-info-top :detail="deviceBusyTop"></alert-info-top>
              </template>

              <empty-component
                v-else
                :imgUrl="require('@/assets/images/info_empty.png')"
                :body-style="{
                  marginTop: '24px'
                }"
                :description-style="{
                  marginTop: '-8px',
                  marginRight: '8px'
                }"
                description="暂无数据"
              ></empty-component>
            </div>
          </div>
        </a-col>

        <a-col :span="8" style="margin-bottom: 16px">
          <div class="top-item">
            <div class="module-header-fs14" style="margin-bottom: 12px">
              设备空闲Top3
            </div>
            <div class="item-card">
              <template v-if="deviceIdleTop && deviceIdleTop.length">
                <alert-info-top :detail="deviceIdleTop"></alert-info-top>
              </template>

              <empty-component
                v-else
                :imgUrl="require('@/assets/images/info_empty.png')"
                :body-style="{
                  marginTop: '24px'
                }"
                :description-style="{
                  marginTop: '-8px',
                  marginRight: '8px'
                }"
                description="暂无数据"
              ></empty-component>
            </div>
          </div>
        </a-col>

        <a-col :span="8" style="margin-bottom: 16px">
          <div class="top-item">
            <div class="module-header-fs14" style="margin-bottom: 12px">
              设备请求Bottom3
            </div>
            <div class="item-card">
              <template
                v-if="deviceRequestBottom && deviceRequestBottom.length"
              >
                <alert-info-top :detail="deviceRequestBottom"></alert-info-top>
              </template>

              <empty-component
                v-else
                :imgUrl="require('@/assets/images/info_empty.png')"
                :body-style="{
                  marginTop: '24px'
                }"
                :description-style="{
                  marginTop: '-8px',
                  marginRight: '8px'
                }"
                description="暂无数据"
              ></empty-component>
            </div>
          </div>
        </a-col>
      </a-row>

      <!-- 按钮 -->
      <div style="text-align: center">
        <a-button type="link" @click="changeDisplay">
          <a-icon v-if="!visible" type="caret-down" />
          <a-icon v-else type="caret-up" />
          <span>{{ visible ? '收起' : '展开' }}</span>
        </a-button>
      </div>
    </a-card>

    <a-card
      :bordered="false"
      style="margin-bottom: 16px"
      :body-style="{ padding: '16px' }"
    >
      <div class="table-operation-container">
        <a-space size="middle" style="float: right">
          <a-input-group :compact="true">
            <a-select
              v-model="searchType"
              :options="tableSearchOptions"
              style="min-width: 96px; border-right: 1px solid #fff"
            >
              <a-icon slot="suffixIcon" type="caret-down"></a-icon>
            </a-select>

            <a-input-search
              placeholder="请输入关键词"
              @search="v => handleSearch(v)"
              style="width: 160px"
            ></a-input-search>
          </a-input-group>
          <!-- 刷新 -->
          <reload-button @click="fetchTableData"></reload-button>

          <!-- 导出 -->
          <export-button
            :columns="columnsAll"
            :default-selected="columnDefaultSelected"
            :export-func="exportFunc"
            :params="fetchParams"
            title="业务真实访问和资源使用情况"
          ></export-button>

          <!-- 设置 -->
          <setting-button
            :columns="columnsAll"
            :default-selected="columnDefaultSelected"
            @selected="v => (columns = v)"
          ></setting-button>
        </a-space>
      </div>

      <a-table
        rowKey="service_id"
        ref="table"
        class="custom-table scroll-hidden-table"
        :data-source="tableData"
        :columns="columns"
        :loading="loading"
        :scroll="{ x: scrollX }"
        :pagination="false"
        @change="handleTableChange"
      >
        <!-- 业务名字 -->
        <template slot="service_name" slot-scope="text">
          <template v-if="text">
            <a-tooltip :title="text">
              {{ text }}
            </a-tooltip>
          </template>
          <span v-else>-</span>
        </template>
        <!-- 责任处室 -->
        <template slot="organizations" slot-scope="text">
          <template v-if="Array.isArray(text) && text.length">
            <a-tooltip
              v-for="item in text"
              :key="item.id"
              :title="item?.name || ''"
            >
              {{ item?.name || '-' }}
            </a-tooltip>
            <span>&nbsp;&nbsp;</span>
          </template>
          <span v-else>-</span>
        </template>

        <!-- 请求数 -->
        <template slot="requests" slot-scope="text, record">
          <div class="chart-history-container">
            <div class="text-overflow">{{ text }}</div>
            <a-tooltip
              placement="bottomRight"
              overlay-class-name="chart-tooltip"
            >
              <template #title>
                <line-chart
                  color-type="type"
                  :show-dot="false"
                  :chartId="`${record.service_id}-request-chart`"
                  :show-legend="false"
                  :chartData="formatChartData(record.requests_list || [])"
                  :height="208"
                  :showArea="true"
                ></line-chart>
              </template>
              <a-button type="link">
                <a-icon type="area-chart" />
              </a-button>
            </a-tooltip>
          </div>
        </template>

        <!-- P95 -->
        <template slot="95th_request_time" slot-scope="text, record">
          <div class="chart-history-container">
            <div class="text-overflow">{{ text }}</div>
            <a-tooltip
              placement="bottomRight"
              overlay-class-name="chart-tooltip"
            >
              <template #title>
                <line-chart
                  color-type="type"
                  :show-dot="false"
                  :chartId="`${record.service_id}-95th_request_time-chart`"
                  :show-legend="false"
                  :chartData="
                    formatChartData(record['95th_request_time_list'] || [])
                  "
                  :height="208"
                  :showArea="true"
                ></line-chart>
              </template>
              <a-button type="link">
                <a-icon type="area-chart" />
              </a-button>
            </a-tooltip>
          </div>
        </template>

        <!-- 平均响应成功率 -->
        <template slot="requests_success_rate" slot-scope="text">
          {{ text }}%
        </template>
      </a-table>

      <div style="height: 36px; margin-top: 16px">
        <a-pagination
          :current="fetchParams.page"
          :pageSize="fetchParams.page_size"
          :show-size-changer="true"
          :show-total="t => `共 ${t} 条`"
          :total="total"
          @change="
            page => {
              fetchParams.page = page
              fetchTableData()
            }
          "
          @showSizeChange="
            (_, pageSize) => {
              fetchParams.page = 1
              fetchParams.page_size = pageSize
              fetchTableData()
            }
          "
          style="float: right"
        ></a-pagination>
      </div>
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import {
  getServiceResourceStatus,
  getDeviceBusyTop,
  getDeviceIdleTop,
  getDeviceRequestBottom,
  getServiceResource,
  exportServiceResource
} from '@/api/boss'
import AlertInfoTop from '@/components/top/AlertInfoTop.vue'
import ExportButton from '@/components/button/ExportButton'
import ReloadButton from '@/components/button/ReloadButton'
import SettingButton from '@/components/button/SettingButton'
import { isNotUndefined } from '@/utils'
import EmptyComponent from '@/components/EmptyComponent.vue'
import LineChart from '@/components/chart/LineChart.vue'

export default {
  name: 'ServiceUsage',
  components: {
    AlertInfoTop,
    EmptyComponent,
    ExportButton,
    ReloadButton,
    SettingButton,
    LineChart
  },
  computed: {
    scrollX () {
      let sum = 0
      this.columns.forEach(column => {
        sum += column.width
      })
      return sum
    }
  },
  data () {
    return {
      isNotUndefined,
      fetchParams: {
        page: 1,
        page_size: 10
      },
      tableSearchOptions: [{ label: '业务系统名称', value: 'service_name' }], // 表格搜索框搜索项
      searchType: 'service_name',
      loading: false, // 表格加载状态
      tableData: [], // 表格数据
      total: 0, // 表格数据总数
      exportFunc: exportServiceResource,
      columnsAll: [
        {
          dataIndex: 'service_name',
          title: '业务系统名称',
          fixed: 'left',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'service_name'
          }
        },
        {
          dataIndex: 'organizations',
          title: '责任处室',
          width: 120,
          ellipsis: true,
          scopedSlots: {
            customRender: 'organizations'
          }
        },
        {
          dataIndex: 'service_construction_manager',
          title: '运维公司对接人',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'service_construction_manager'
          }
        },
        {
          dataIndex: 'requests',
          title: '请求数',
          width: 140,
          scopedSlots: {
            customRender: 'requests'
          },
          sorter: true
        },
        {
          dataIndex: 'average_requests',
          title: '平均请求数',
          width: 140,
          scopedSlots: {
            customRender: 'average_requests'
          },
          sorter: true
        },
        {
          dataIndex: '95th_request_time',
          title: 'P95',
          width: 140,
          scopedSlots: {
            customRender: '95th_request_time'
          },
          sorter: true
        },
        {
          dataIndex: 'average_95th_request_time',
          title: '平均P95',
          width: 140,
          scopedSlots: {
            customRender: 'average_95th_request_time'
          },
          sorter: true
        },
        {
          dataIndex: 'requests_success_rate',
          title: '平均响应成功率',
          width: 152,
          scopedSlots: {
            customRender: 'requests_success_rate'
          },
          sorter: true
        },
        {
          dataIndex: 'busy',
          title: '繁忙设备',
          width: 140,
          scopedSlots: {
            customRender: 'busy'
          },
          sorter: true
        },
        {
          dataIndex: 'idle',
          title: '空闲设备',
          width: 140,
          scopedSlots: {
            customRender: 'idle'
          },
          sorter: true
        },
        {
          dataIndex: 'health',
          title: '健康度',
          width: 140,
          scopedSlots: {
            customRender: 'health'
          },
          sorter: true
        }
      ],
      columnDefaultSelected: [
        'service_name',
        'organizations',
        'service_construction_manager',
        'requests',
        '95th_request_time',
        'requests_success_rate',
        'busy',
        'idle',
        'health'
      ],
      columns: [],
      visible: false, // 更多统计展示,
      sourceId: '',
      historyFunc: undefined,
      resourceStatusData: {
        '95th_request_time': null,
        busy_count: null,
        health_score_count: null,
        idle_count: null,
        request_count: null,
        requests_success_rate: null
      }, // 统计头状态数据
      deviceBusyTop: [],
      deviceIdleTop: [],
      deviceRequestBottom: []
    }
  },
  mounted () {
    this.columns = this.columnsAll.filter(
      column => this.columnDefaultSelected.indexOf(column.dataIndex) !== -1
    )
    this.fetch()
  },
  methods: {
    changeDisplay () {
      this.visible = !this.visible
    },
    fetch () {
      this.fetchTopData()
      this.fetchResourceStatus()
      this.fetchTableData()
    },
    fetchResourceStatus () {
      getServiceResourceStatus().then(res => {
        if (res.data && Object.keys(res.data).length) {
          this.resourceStatusData = res.data
        } else {
          this.resourceStatusData = {
            '95th_request_time': null,
            busy_count: null,
            health_score_count: null,
            idle_count: null,
            request_count: null,
            requests_success_rate: null
          }
        }
      })
    },
    fetchTopData () {
      getDeviceBusyTop().then(res => {
        this.deviceBusyTop = res.data.map(item => {
          return {
            name: item.name,
            value: item.count,
            id: item.id
          }
        })
      })
      getDeviceIdleTop().then(res => {
        this.deviceIdleTop = res.data.map(item => {
          return {
            name: item.name,
            value: item.count,
            id: item.id
          }
        })
      })
      getDeviceRequestBottom().then(res => {
        this.deviceRequestBottom = res.data.map(item => {
          return {
            name: item.name,
            value: item.count,
            id: item.id
          }
        })
      })
    },
    fetchTableData () {
      this.loading = true
      getServiceResource(this.fetchParams)
        .then(res => {
          const data = res.data
          if (data) {
            this.total = data.total
            this.tableData = data.data
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSearch (value) {
      if (value !== '') {
        this.fetchParams[this.searchType] = value
      } else {
        delete this.fetchParams[this.searchType]
      }
      this.fetchParams.page = 1
      this.fetchTableData()
    },
    handleTableChange (pagination, filters, sorter) {
      const { order, field } = sorter

      if (order) {
        this.fetchParams.sort_by = field
        this.fetchParams.order_by = order
        if (order === 'ascend') this.fetchParams.order_by = 'asc'
        else if (order === 'descend') this.fetchParams.order_by = 'desc'
      } else {
        delete this.fetchParams.sort_by
        delete this.fetchParams.order_by
      }
      this.fetchParams.page = 1
      this.fetchTableData()
    },
    formatChartData (v) {
      if (v && v.length) {
        return v.map(item => {
          return {
            date: moment(item.timestamp).format('YYYY-MM-DD HH:mm'),
            value: item.value,
            type: '数据'
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.statistics-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(188px, 1fr));
  gap: 16px;

  .statistic-item {
    .item-card {
      color: #1677ff;
      width: 100%;
      height: 84px;
      border-radius: 6px;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      text-align: center;
      display: flex;
      flex-wrap: wrap;
      align-content: center;
      justify-content: center;
      background-image: url('../../../assets/images/service-monitor/statistic-item.png');

      .title {
        font-size: 12px;
        width: 100%;
      }

      .value {
        font-size: 30px;
        font-weight: 500;
        width: 100%;
      }
    }
  }
}

.top-container {
  margin-top: 22px;

  .top-item {
    .item-card {
      min-height: 164px;
    }
  }
}

.table-operation-container {
  height: 34px;
  margin-bottom: 16px;
  font-size: 16px;
  line-height: 34px;
  overflow: hidden;
}

.chart-history-container {
  display: grid;
  grid-template-columns: auto 60px;
  align-items: center;
}
</style>
